import { PriceFeedInstrumentType } from '../../components/atoms/PriceFeedStore';

function instrumentToExchange(payload: PriceFeedInstrumentType) {
	if (payload.brokerExchange === 'N') {
		if (payload.brokerExchangeType === 'C') {
			return 'NSEEQ';
		}
		if (payload.brokerExchangeType === 'D') {
			return 'NSEFO';
		}
		if (payload.brokerExchangeType === 'U') {
			return 'NSECURR';
		}
		if (payload.brokerExchangeType === 'Y') {
			return 'NSECOMM';
		}
		if (payload.brokerExchangeType === 'X') {
			return 'NCDEXCOMM';
		}
	}

	if (payload.brokerExchange === 'B') {
		if (payload.brokerExchangeType === 'C') {
			return 'BSEEQ';
		}
		if (payload.brokerExchangeType === 'D') {
			return 'BSEFO';
		}
		if (payload.brokerExchangeType === 'U') {
			return 'BSECURR';
		}
		if (payload.brokerExchangeType === 'Y') {
			return 'BSECOMM';
		}
	}

	if (payload.brokerExchange === 'M') {
		if (payload.brokerExchangeType === 'D') {
			return 'MCXCOMM';
		}
	}

	return '' as never;
}

export function instrumentToExchangeMap(payload: PriceFeedInstrumentType) {
	return `${instrumentToExchange(payload).toLowerCase()}/${payload.brokerCode}`;
}

export function instrumentToMqttFeedItem(payload: PriceFeedInstrumentType) {
	return instrumentToExchangeMap(payload);
}

export function instrumentToExchangeReverseMap(payload: string): PriceFeedInstrumentType {
	const [exchange, brokerCodeString] = payload.split('/');
	const brokerCode = parseInt(brokerCodeString);

	const exchangeUpper = exchange.toUpperCase();

	// Reverse mapping from exchange format to (brokerExchange, brokerExchangeType)
	const reverseMapping: Record<string, { brokerExchange: string; brokerExchangeType: string }> = {
		NSEEQ: { brokerExchange: 'N', brokerExchangeType: 'C' },
		NSEFO: { brokerExchange: 'N', brokerExchangeType: 'D' },
		NSECURR: { brokerExchange: 'N', brokerExchangeType: 'U' },
		NSECOMM: { brokerExchange: 'N', brokerExchangeType: 'Y' },
		NCDEXCOMM: { brokerExchange: 'N', brokerExchangeType: 'X' },
		BSEEQ: { brokerExchange: 'B', brokerExchangeType: 'C' },
		BSEFO: { brokerExchange: 'B', brokerExchangeType: 'D' },
		BSECURR: { brokerExchange: 'B', brokerExchangeType: 'U' },
		BSECOMM: { brokerExchange: 'B', brokerExchangeType: 'Y' },
		MCXCOMM: { brokerExchange: 'M', brokerExchangeType: 'D' },
	};

	const mapping = reverseMapping[exchangeUpper] || { brokerExchange: 'N', brokerExchangeType: 'C' };

	return {
		brokerCode,
		brokerExchange: mapping.brokerExchange,
		brokerExchangeType: mapping.brokerExchangeType,
	};
}
